export default "__VITE_ASSET__Bwi_mQNN__"